import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Avatar } from "@chakra-ui/avatar";
import { Button, IconButton } from "@chakra-ui/button";
import { useColorModeValue } from "@chakra-ui/color-mode";
import { useDisclosure } from "@chakra-ui/hooks";
import { Box, Flex, Stack } from "@chakra-ui/layout";
import { useNavigate } from "react-router-dom";

import {
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";

import { AiOutlineShoppingCart } from "react-icons/ai";
import { CiSearch } from "react-icons/ci";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { ChevronRightIcon, HamburgerIcon } from "@chakra-ui/icons";
import { BiSolidUserCircle } from "react-icons/bi";

import jwt_decode from "jwt-decode";

import footerlogo from "../../assets/Home/logoFooter.png";
import { getCart } from "../../Redux/ProductController/action";
import {
  BASE_URL_MEDIA,
  BASE_URL_SEARCH,
  BASE_URL_USER,
} from "../../Redux/App/action";
import { navTab } from "./navData";
import OurOffers from "./OurOffers";
import { profile_item } from "../../Constants/index";

const NewNavbar = (props) => {
  const { hideSearchResult, hideSearchResultHandler } = props;
  const [webview, setWebview] = useState(false);
  const toast = useToast();
  const { isOpen, onToggle } = useDisclosure();
  const popoverContentBgColor = useColorModeValue("#200e32", "gray.800");
  const linkColor = useColorModeValue("gray.600", "gray.200");
  const linkHoverColor = useColorModeValue("gray.800", "white");
  const [profileData, setProfileData] = useState([]);
  const accessToken = localStorage.getItem("token");
  const [login, setLogin] = useState(accessToken);
  const [sId, setSId] = useState("");
  const dispatch = useDispatch();

  const [profileName, setProfileName] = useState("");
  const [imageData, setImageData] = useState("");
  const [search, setSearch] = useState("");

  const [searchResults, setSearchResults] = useState([]);

  const [isFetching, setIsFetching] = useState(false);
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");

  useEffect(() => {
    const buildString = navigator.userAgent.includes("Build");
    const sysType = navigator.userAgent.includes("Linux");
    const osType = navigator.userAgent.includes("Android");
    setWebview(buildString && sysType && osType);
  }, []);

  useEffect(() => {
    const getSearchResult = setTimeout(() => {
      if (search && search?.length >= 3) {
        setIsFetching(true);
        fetch(`${BASE_URL_SEARCH}/search/byFirstThreeLetters?query=${search}`)
          .then((response) => response.json())
          .then((data) => {
            setSearchResults(data);
            hideSearchResultHandler(true);
            setIsFetching(false);
          })
          .catch((error) => {
            setIsFetching(false);
            console.error("Error fetching data:", error);
          });
      } else {
        setSearchResults([]);
        hideSearchResultHandler(false);
      }
    }, 500);

    return () => clearTimeout(getSearchResult);
  }, [search, hideSearchResultHandler]);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;

          getLocationName(latitude, longitude);
        },
        (error) => {
          console.error("Error getting user location: ", error);
        }
      );
    } else {
      //Show Alert As Well To User
      toast({
        title: "Geolocation Not Supported !",
        description: "Geolocation Not Supported !",
        status: "error",
        duration: 3000,
        isClosable: true,
      });

      console.error("Geolocation is not supported by this browser.");
    }
  };

  const getProfileData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response) {
        if (response?.status === 200) {
          setProfileData(response?.data?.payload);
          setProfileName(response.data.payload.fullName);
          setSId(response.data.payload.userImg);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [accessToken]);

  const getLocationName = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
      );
      if (response.status === 200) {
        setState(response.data.address.state);
        setName(response.data.address.hamlet);
        setCity(response.data.address.city);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  const getProfileImage = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/media/file/admin/get/base64?sourceMediaId=${sId}&dimension=ORIGINAL`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setImageData(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [accessToken, sId]);

  useEffect(() => {
    if (login) {
      setLogin(localStorage.getItem("user"));
      dispatch(getCart());
    }
  }, [dispatch, login]);

  useEffect(() => {
    if (login && sId !== "" && sId !== null) {
      getProfileImage();
    }
  }, [getProfileImage, login, sId]);

  useEffect(() => {
    if (login) {
      getProfileData();
    }
  }, [getProfileData, login]);

  const handleClose = () => {
    if (isOpen) {
      onToggle();
    }
  };

  // Checking if refresh token is expired
  const refresh_token = localStorage.getItem("refresh");
  useEffect(() => {
    try {
      const decodedRefreshToken = jwt_decode(refresh_token);
      const refreshExpirationTime = decodedRefreshToken.exp;
      const currentTime = Math.floor(Date.now() / 1000);
      if (refreshExpirationTime < currentTime) {
        setLogin(false);
        localStorage.removeItem("user");
      } else {
        console.log("Refresh token is still valid");
      }
    } catch (error) {
      console.error("Invalid or malformed token:", error);
      setLogin(false);
    }
  }, [refresh_token]);

  const DesktopSubNav = ({ label, href, subLabel }) => {
    return (
      <Box
        as="a"
        href={href}
        role={"group"}
        display={"block"}
        p={2}
        h={"100%"}
        rounded={"md"}
        _hover={{ bg: useColorModeValue("pink.50", "gray.900") }}
      >
        <Stack direction={"row"} align={"center"}>
          <Box>
            <Text
              transition={"all .3s ease"}
              _groupHover={{ color: "pink.400" }}
              fontWeight={500}
            >
              {label}
            </Text>
            <Text fontSize={"sm"}>{subLabel}</Text>
          </Box>
          <Flex
            transition={"all .3s ease"}
            transform={"translateX(-10px)"}
            opacity={0}
            _groupHover={{ opacity: "100%", transform: "translateX(0)" }}
            justify={"flex-end"}
            align={"center"}
            flex={1}
          >
            <Icon color={"pink.400"} w={5} h={5} as={ChevronRightIcon} />
          </Flex>
        </Stack>
      </Box>
    );
  };

  if (webview) {
    return;
  }

  return (
    <>
      <div className="flex justify-between items-center px-3 sm:px-9 lg:px-14 py-1 bg-[#372449] text-white z-50 xsm:space-x-8">
        <div className="flex justify-between items-center">
          {/* Hamburger Menu Icon */}
          <div className="block sm:hidden">
            <Menu>
              <MenuButton
                as={IconButton}
                aria-label="Options"
                icon={<HamburgerIcon color={"white"} size={12} />}
                bg={"transparent"}
                _hover={{ bg: "transparent" }}
                border={"transparent"}
                variant="outline"
              />

              <MenuList color={"white"} bg={"#464957"}>
                {navTab.map((navData, i) => {
                  return (
                    <Link to={navData.link} key={i}>
                      <MenuItem bg={"#464957"} fontWeight={"bold"}>
                        {navData.name}
                      </MenuItem>
                    </Link>
                  );
                })}
              </MenuList>
            </Menu>
          </div>

          <div className="w-28 xsm:w-[9em] lg:w-[8.2em]">
            {/* Logo */}
            <Link to={"/"} onClick={handleClose}>
              <img src={footerlogo} alt="main header logo" />
            </Link>
          </div>
        </div>

        <div className="flex justify-center items-center space-x-3">
          <div>
            {/* Your address */}
            <div
              className="hidden justify-start space-x-2 items-center pl-5 sm:flex cursor-pointer"
              onClick={getCurrentLocation}
            >
              <HiOutlineLocationMarker className="w-4 h-4" />
              <p className="whitespace-nowrap text-[#848484] hidden text-[15px] lg:block">
                {name ? (
                  <>
                    {name}, {city}
                    <br />
                    {state}
                  </>
                ) : (
                  "Select your address"
                )}
              </p>
            </div>
          </div>

          <div className="relative flex-initial w-[25em] bg-[#200E32] rounded xl:w-[30em] z-50 hidden sm:block">
            {/* Input field */}
            <div className="relative">
              <input
                className="bg-[#200e32] text-[#dedede] border-0 rounded outline-none  px-[2em] py-[8px] w-1/3 md:w-full sm:w-full placeholder:text-[#848484]"
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                value={search}
                placeholder="Search..."
              />
              <div className="absolute top-3 text-[#848484] left-2">
                <CiSearch />
              </div>
            </div>
            {hideSearchResult && searchResults.length !== 0 ? (
              <div
                className={`text-white absolute top-[100%] left-0 w-1/3 md:w-full sm:w-full max-w-[25em] xl:max-w-[30em] bg-[#200E32] rounded-b-lg no-scrollbar ${
                  searchResults.length > 7 ? "overflow-y-scroll" : ""
                } max-h-[80vh] -mt-1`}
              >
                <div className="h-[0.5px] bg-slate-700 mx-3"></div>

                {searchResults &&
                  searchResults?.map((result) => {
                    return (
                      <Link
                        key={result?.productId}
                        to={`/${
                          result?.displayName === "Greetings" ||
                          result?.displayName === "Invitations"
                            ? "shareCards"
                            : "productDetails"
                        }/${result?.productId}`}
                      >
                        <div
                          className="flex justify-between items-center p-2 rounded-lg"
                          onClick={() => {
                            setSearch("");
                          }}
                        >
                          <div className="flex justify-between items-center gap-2">
                            <img
                              className="w-[30px] rounded-full"
                              src={result.img}
                              alt="error"
                            />
                            <div className="text-left">
                              <p className="text-[13px]">
                                {result.productName}
                              </p>
                              <p className="text-[#9c9c9c] text-[12px]">
                                in {result.displayName}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
              </div>
            ) : (
              <></>
            )}
            {hideSearchResult &&
            searchResults?.length === 0 &&
            search?.length !== 0 ? (
              <div
                className={`text-white absolute top-[100%] p-4 left-0 w-1/3 md:w-full sm:w-full max-w-[25em] xl:max-w-[30em] bg-[#200E32] rounded-b-lg no-scrollbar`}
              >
                Product Not Available
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="flex justify-between items-center xsm:space-x-4 lg:space-x-8">
          {login ? (
            <div
              className="hidden cursor-pointer lg:block whitespace-nowrap text-sm"
              onClick={() => {
                navigate("/myprofile");
              }}
            >
              <p>
                Hello,{" "}
                {profileName?.length > 0 ? profileName?.split(" ")[0] : "User"}
              </p>
            </div>
          ) : (
            <></>
          )}

          <div>
            {/* if user is login or not */}
            {login ? (
              <Box>
                <Box display={"flex"} flexDirection={"row"} w={"100%"}>
                  {profile_item.map((profile_item) => (
                    <Box key={profile_item.label}>
                      <Popover trigger={"click"} placement={"bottom-start"}>
                        <PopoverTrigger>
                          <Box
                            as="a"
                            p={{ md: 2, base: 0 }}
                            href={profile_item.href}
                            fontSize={"14px"}
                            fontWeight={"bold"}
                            color={linkColor}
                            _hover={{
                              textDecoration: "none",
                              color: linkHoverColor,
                            }}
                          >
                            <Avatar
                              size="sm"
                              name={profileData.fullName}
                              src={`data:image/png;base64,${imageData}`}
                              cursor={"pointer"}
                              ml={{ base: -2 }}
                            />
                          </Box>
                        </PopoverTrigger>
                        {profile_item.children && (
                          <PopoverContent
                            border={0}
                            boxShadow={"xl"}
                            fontSize={"14px"}
                            bg={popoverContentBgColor}
                            p={1}
                            rounded={"xl"}
                            w={"100%"}
                            _hover={{ cursor: "pointer" }}
                            color={"white"}
                          >
                            <Stack>
                              {profile_item.children.map((child) => (
                                <DesktopSubNav key={child.label} {...child} />
                              ))}
                            </Stack>
                          </PopoverContent>
                        )}
                      </Popover>
                    </Box>
                  ))}
                </Box>
              </Box>
            ) : (
              <Link to={"/authenticate"}>
                <Button
                  bgGradient="linear(to-r, #FC1B68,#FE1745)"
                  color={"white"}
                  _hover={{
                    bgGradient: "linear(to-r, #FC1B68,#FE1745)",
                    boxShadow: "xl",
                  }}
                  borderRadius={20}
                  h={8}
                  ml={-5}
                >
                  <Flex
                    alignItems={"center"}
                    gap={1}
                    className="lato-font"
                    fontWeight={"normal"}
                  >
                    Login
                    <BiSolidUserCircle color="white" size={24} />
                  </Flex>
                </Button>
              </Link>
            )}
          </div>

          <div>
            {/* Add to cart logo */}
            <div>
              <Link to="/Cart/AddToCart">
                <div className="flex justify-center items-center gap-2">
                  <div>
                    <AiOutlineShoppingCart className="w-6 h-6" />
                    <p>{}</p>
                  </div>
                  <p className="hidden lg:block">Cart</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Our Offer : what we provide to the customer */}
      <OurOffers />
    </>
  );
};
export default NewNavbar;
